<template>
  <div class="information">
    <div class="info" v-for="(item,i) in showForm.infos" :key="i">
      <h5>{{item.title}}</h5>
      <div class="box">
        <div class="line flex">
          <div class="tt">使用目的</div>
          <div class="dd">{{item.file1}}</div>
        </div>
        <div class="line flex">
          <div class="tt">使用目的</div>
          <div class="dd">{{item.file2}}</div>
        </div>
        <div class="line flex">
          <div class="tt">使用目的</div>
          <div class="dd">{{item.file3}}</div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      forms: [],
      showForm: {},
    };
  },
  mounted() {
    this.forms = [
      {
        value: 1,
        name: "用户基本信息",
        infos: [
          {
            title: "1. 昵称/用户名",
            file1: "用于完善网络身份标识",
            file2: "用户注册、登录",
            file3: "用户提供",
          },
          {
            title: "2. 头像",
            file1: "用于展示头像信息",
            file2: "用于个人信息/评价等页面信息展示",
            file3: "用户提供",
          },
          {
            title: "3. 生日",
            file1: "用于个人信息补充",
            file2: "用户自行编辑资料",
            file3: "未收集",
          },
          {
            title: "4. 地址",
            file1: "用于用户下单完成履约服务",
            file2: "用户每次下单时",
            file3: "用户提供",
          },
        ],
      },
      {
        value: 2,
        name: "用户身份信息",
        infos: [
          {
            title: "1. 姓名",
            file1: "用于进行实名认证",
            file2: "用户首次实名认证时",
            file3: "用户提供",
          },
          {
            title: "2. 手机号码",
            file1: "用于注册创建账号和登录",
            file2: "用户注册、登录及实名认证",
            file3: "用户提供",
          },
          {
            title: "3. 身份证号",
            file1: "用于进行实名认证",
            file2: "用户首次实名认证时",
            file3: "用户提供",
          },
          {
            title: "4. 银行卡号",
            file1: "用于完成在线支付功能",
            file2: "用户支付过程中",
            file3: "未收集",
          },
        ],
      },
      {
        value: 3,
        name: "账户信息",
        infos: [
          {
            title: "1. 第三方账号",
            file1: "用于使用第三方账号授权登录",
            file2: "用户使用第三方账号登录",
            file3: "未收集",
          },
        ],
      },
      {
        value: 4,
        name: "位置信息",
        infos: [
          {
            title: "1. 位置信息",
            file1: "根据用户的位置推荐周边的生活服务",
            file2: "使用App过程中",
            file3: "用户提供",
          },
        ],
      },
      {
        value: 5,
        name: "设备信息",
        infos: [
          {
            title: "1. IMEI",
            file1: "用于识别设备，进行信息推送和安全保障等功能",
            file2: "使用App过程中",
            file3: "未收集",
          },
          {
            title: "2.IDFA",
            file1: "用于识别设备，进行信息推送和安全保障等功能",
            file2: "使用App过程中",
            file3: "未收集",
          },
          {
            title: "3.OPENUDID",
            file1: "用于识别设备，进行信息推送和安全保障等功能",
            file2: "使用App过程中",
            file3: "未收集",
          },
          {
            title: "4.GUIDIMSI",
            file1: "用于识别设备，进行信息推送和安全保障等功能",
            file2: "使用App过程中",
            file3: "未收集",
          },
          {
            title: "5.Android ID",
            file1: "用于识别设备，进行信息推送和安全保障等功能",
            file2: "使用App过程中",
            file3: "未收集",
          },
          {
            title: "6.OAID",
            file1: "用于识别设备，进行信息推送和安全保障等功能",
            file2: "使用App过程中",
            file3: "未收集",
          },
          {
            title: "7.ICCID",
            file1: "用于识别设备，进行信息推送和安全保障等功能",
            file2: "使用App过程中",
            file3: "未收集",
          },
          {
            title: "8.设备型号和名称",
            file1: "用于兼容性判断和安全保障等功能",
            file2: "使用App过程中",
            file3: "用户提供",
          },
          {
            title: "9. CPU型号",
            file1: "用于兼容性判断和安全保障等功能",
            file2: "使用App过程中",
            file3: "用户提供",
          },
          {
            title: "10. 设备GSM网络类型",
            file1: "用于兼容性判断和安全保障等功能",
            file2: "使用App过程中",
            file3: "用户提供",
          },
          {
            title: "11. 设备制造商",
            file1: "用于兼容性判断和安全保障等功能",
            file2: "使用App过程中",
            file3: "用户提供",
          },
          {
            title: "12. IP地址",
            file1: "用于兼容性判断和安全保障等功能",
            file2: "使用App过程中",
            file3: "用户提供",
          },
          {
            title: "13. 操作系统版本",
            file1: "用于兼容性判断和安全保障等功能",
            file2: "使用App过程中",
            file3: "用户提供",
          },
          {
            title: "14. 电信运营商",
            file1: "用于用户登录",
            file2: "使用一键登录功能",
            file3: "用户提供",
          },
        ],
      },
    ];
    var type = this.$route.query.type || 1;
    
    for (const i in this.forms) { 
      if (type == this.forms[i].value) {
        this.showForm = this.forms[i];
      }
    }
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import url("../../assets/style/rem.css");
.information {
  padding: 0.3rem;

  .info {
    h5 {
      margin-bottom: 0.3rem;
    }

    .box {
      border: 1px solid #f8f8f8;
      margin-bottom: 0.3rem;

      .line {
        border-bottom: 1px solid #f8f8f8;

        &:last-child {
          border: none;
        }

        .tt {
          background: #eee;
          width: 1.6rem;
          border-right: 1px solid #f8f8f8;
          text-align: center;
          padding: 0.2rem 0;
          margin-right: 0.2rem;
        }
      }
    }
  }
}
</style>